import styled from 'styled-components';

export const LabelContainer = styled.div`
  margin-left: 0.125rem;
`;

export const GreenLabel = styled.span`
  background-color: #dbe9db;
  margin: 0.5rem;
  border-radius: 0.25rem;
  padding: 0.25rem;
`;

export const YellowLabel = styled.span`
  background-color: #faf1d1;
  margin: 0.5rem;
  border-radius: 0.25rem;
  padding: 0.25rem;
`;

export const RedLabel = styled.span`
  background-color: #ffbeae;
  margin: 0.5rem;
  border-radius: 0.25rem;
  padding: 0.25rem;
`;

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 0.25rem;
`;

export const SwitchWrapper = styled.div`
  margin-left: 0.5rem;
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;
`;
